import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";

import "./Apropos.css";
import AproposData from "./AproposData";

import DriverVideo from "../../video/video1.mp4";
import ClientVideo from "../../video/test.mp4";

const API = process.env.REACT_APP_API_URL || "http://localhost:5002";

const Apropos = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [formMessage, setFormMessage] = useState("");
  const [formError, setFormError] = useState("");

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    type_projet: "",
    entreprise: "",
    telephone: "",
    message: "",
  });

  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: false,
      mirror: true,
    });
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (formMessage) setFormMessage("");
    if (formError) setFormError("");
  };

  const sendEmail = async (e) => {
    e.preventDefault();

    try {
      setIsSending(true);
      setFormError("");
      setFormMessage("");

      await axios.post(`${API}/api/contact`, formData);

      setIsSuccess(true);
      setFormMessage("Votre formulaire a bien été envoyé. Nous revenons vers vous rapidement.");

      setFormData({
        name: "",
        email: "",
        type_projet: "",
        entreprise: "",
        telephone: "",
        message: "",
      });

      setTimeout(() => {
        setIsSuccess(false);
        setFormMessage("");
        setIsModalOpen(false);
      }, 5000);
    } catch (error) {
      setFormError("Une erreur est survenue lors de l’envoi du formulaire. Veuillez réessayer.");
      console.log(error?.response?.data || error.message);
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="Apropos" data-aos="fade-up">
      <h1 data-aos="fade-up" data-aos-duration="500" data-aos-once="false">
        Une application VTC plus juste, plus efficace.
      </h1>

      <h3 data-aos="fade-up" data-aos-duration="500" data-aos-once="false">
        Nous construisons une plateforme qui respecte ceux qui travaillent,
        et qui récompense aussi les utilisateurs : commission plus basse,
        meilleures conditions chauffeurs, promos clients et expérience fluide.
      </h3>

      <AproposData
        className="first-des"
        heading="Pour les chauffeurs : plus de CA, moins de commission"
        text="Rejoignez une plateforme pensée pour augmenter votre chiffre d’affaires : une commission 2 à 3 fois plus basse que le marché, une meilleure répartition des courses, et une vision long terme basée sur le respect du métier. Moins de frais, plus de revenus, et une relation plus saine avec les clients."
        video1={DriverVideo}
        data-aos="fade-left"
      />

      <AproposData
        className="first-des-reverse"
        heading="Pour les clients : promos, sérénité et efficacité"
        text="Profitez d’une expérience plus fiable : promotions sur plus de 50% de vos courses (selon disponibilité et périodes), plus de sérénité et une prise en charge optimisée. Et surtout : une démarche responsable — chaque course impacte directement le quotidien du chauffeur. Choisir une plateforme plus juste, c’est aussi soutenir ceux qui vous transportent."
        video1={ClientVideo}
        data-aos="fade-right"
      />

      <div className="apropos-cards" data-aos="fade-up" data-aos-duration="600">
        <div className="apropos-card" data-aos="zoom-in">
          <h4>Commission ultra-compétitive</h4>
          <p>
            Objectif : une commission 2 à 3× plus basse que les standards,
            pour que le chauffeur garde l’essentiel.
          </p>
        </div>

        <div className="apropos-card" data-aos="zoom-in" data-aos-delay="100">
          <h4>Plus de valeur pour le client</h4>
          <p>
            Promotions sur une grande partie des courses + transparence
            + parcours de réservation simple et rapide.
          </p>
        </div>

        <div className="apropos-card" data-aos="zoom-in" data-aos-delay="200">
          <h4>Responsabilité & respect</h4>
          <p>
            Une course, ce n’est pas “juste un trajet” : c’est le travail
            de quelqu’un. Notre modèle encourage une relation saine.
          </p>
        </div>
      </div>

      <div
        className="apropos-button-container"
        data-aos="fade-up"
        data-aos-duration="500"
        data-aos-once="false"
      >
        <button
          className="apropos-button"
          onClick={() => {
            setIsModalOpen(true);
            setFormError("");
            setFormMessage("");
          }}
        >
          Rejoindre
        </button>
      </div>

      {isModalOpen && (
        <div className="modal-overlay" data-aos="zoom-in">
          <div className="modal-content">
            <span
              className="close-button"
              onClick={() => {
                setIsModalOpen(false);
                setFormError("");
                setFormMessage("");
              }}
            >
              &times;
            </span>

            <h2>Contact / Partenariat</h2>

            {formMessage && (
              <div className="form-success-message">
                ✔️ {formMessage}
              </div>
            )}

            {formError && (
              <div className="form-error-message">
                {formError}
              </div>
            )}

            <form onSubmit={sendEmail}>
              <label>Vous êtes :</label>
              <select
                name="type_projet"
                value={formData.type_projet}
                onChange={handleChange}
                required
              >
                <option value="">Sélectionnez...</option>
                <option value="Chauffeur VTC">Chauffeur VTC</option>
                <option value="Client">Client</option>
                <option value="Partenaire (flotte / entreprise)">
                  Partenaire (flotte / entreprise)
                </option>
                <option value="Autre">Autre</option>
              </select>

              <label>Nom :</label>
              <input
                type="text"
                name="name"
                placeholder="Nom complet"
                value={formData.name}
                onChange={handleChange}
                required
              />

              <label>Email :</label>
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
              />

              <label>Téléphone :</label>
              <input
                type="tel"
                name="telephone"
                placeholder="Votre numéro"
                value={formData.telephone}
                onChange={handleChange}
                required
              />

              <label>Entreprise (si applicable) :</label>
              <input
                type="text"
                name="entreprise"
                placeholder="Nom de l'entreprise"
                value={formData.entreprise}
                onChange={handleChange}
              />

              <label>Message :</label>
              <textarea
                name="message"
                placeholder="Expliquez votre besoin (chauffeur / client / partenariat)..."
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>

              <button type="submit" disabled={isSending}>
                {isSending ? "Envoi..." : "Envoyer"}
              </button>
            </form>
          </div>
        </div>
      )}

      {isSuccess && (
        <div className="success-message">
          <span className="success-icon">✔️</span>
          <p>Votre message a été envoyé avec succès !</p>
          <p>Nous revenons vers vous rapidement.</p>
        </div>
      )}
    </div>
  );
};

export default Apropos;